/**
 * @license
 * Copyright (c) Absa Group Limited, All Rights Reserved.
 */

import { MessageCount } from './models/messages.model';
import { Subscription } from 'rxjs/Subscription';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MessagesService } from './services/messages.service';
import { Observable } from 'rxjs';
import { NotificationService } from '@threshold/components/notifications/services/notification.service';
import { Store } from '@ngrx/store';
import * as thresholdActions from '../../store/actions/actions';

@Component({
	selector: 'celine-notifications-bell',
    template: `
        <div class="masthead__wrapper" (click)="notificationLink()">
            <i class="masthead__icon ico icon-email">
                <div *ngIf="notifications != 0" class="notification-pulse"></div>
                <span class="notification-no" *ngIf="notifications != 0" ></span>
            </i>
            <span class="masthead__label">{{ 'CELINE_MESSAGES' | translate }}</span>
        </div>
    `,
    styles: [`

        .icon-email {
            background-image: none;
            line-height: 27px !important;
        }

        .notification-no {
            position: absolute;
            background: #F02849;
            border-radius: 50%;
            height: 10px;
            width: 10px;
            top: 7px;
            left: 26px;
            margin: auto;
            text-align: center;
            z-index: 2;
        }

        .notification-pulse {
            position: absolute;
            height: 18px;
            width: 18px;
            z-index: 1;
            top: 3px;
            left: 22px;
            border: 5px solid #F02849;
            border-radius: 50%;
            animation: notification-pulse 2s ease-out infinite;
        }

        @keyframes notification-pulse {
            0% {
                -webkit-transform: scale(0);
                opacity: 0.0;
            }

            25% {
                -webkit-transform: scale(0.1);
                opacity: 0.1;
            }

            50% {
                -webkit-transform: scale(0.5);
                opacity: 0.3;
            }

            75% {
                -webkit-transform: scale(0.8);
                opacity: 0.5;
                }

            100% {
                -webkit-transform: scale(1);
                opacity: 0.0;
            }
        }
    `]
})

export class NotificationsBellComponent implements OnDestroy, OnInit {

    public notifications: number;
    public subscription: Subscription;
    public pollSubscription: Subscription;
    public msgSubscription: Subscription;
    private config = process.env.config;

    /**
	 *
	 */
    constructor(private store: Store<any>, private router: Router, private messagesService: MessagesService, private notificationService: NotificationService) {
        this.subscription = this.notificationService.getNotificationCount().subscribe(count => {
            this.notifications = count;
        })
    }

	/**
	 *
	 */
    ngOnInit(): void {
        this.getMessageCount();
        this.pollSubscription = Observable.interval(this.config.feature.notification.pollingInterval)
            .subscribe(this.getMessageCount.bind(this));
    }

    public notificationLink() {
        if (process.env.config.isProduction) {
            this.store.dispatch(new thresholdActions.SetAllowExternalNavigationAction(true)); // allow redirects
            window.location.href = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '') + '/v2/#/notifications';
        }
        else
            this.router.navigate(['/notifications']);
    }

    ngOnDestroy() {
        // unsubscribe to ensure no memory leaks
        this.msgSubscription.unsubscribe();
        this.subscription.unsubscribe();
        this.pollSubscription.unsubscribe();
    }

    private getMessageCount() {
        if (this.msgSubscription) {
            this.msgSubscription.unsubscribe();
        }
        this.msgSubscription = this.messagesService.getUnreadMessages()
            .subscribe((data: MessageCount) =>
                {
                    this.notifications = data.unreadMessages ? data.unreadMessages : 0;
                },
                err => {
                    // if http fails... stop polling
                    this.pollSubscription.unsubscribe();
                });
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/components/notifications/notifications-bell.component.ts